export default "__VITE_ASSET__CCaVDsbi__"